import React, { useState, useEffect } from "react"
import Img from "gatsby-image"

const Gallery = props => {
  const indexLimit = props.gallery.length
  const [currentIndex, setCurrentIndex] = useState(0)

  let images = props.gallery.map((img, i) => {
    return <Img fluid={img.fluid} />
  })

  useEffect(() => {
    window.document.onkeydown = checkKey
  }, [checkKey])

  function checkKey(e) {
    const buttonNext = document.getElementById("increase");
    const buttonBack = document.getElementById("decrease");
    e = e || window.event
    if (e.keyCode == "37") {
        buttonBack.click();
    } else if (e.keyCode == "39") {
        buttonNext.click();
    }
  }

  const increaseIndex = () => {
    if (currentIndex < indexLimit - 1) {
      setCurrentIndex(currentIndex + 1)
    } else {
      return null
    }
  }

  const decreaseIndex = () => {
    if (currentIndex === 0) {
      return null
    } else {
      setCurrentIndex(currentIndex - 1)
    }
  }

  return (
    <div class="gallery">
      {images[currentIndex]}
        <div id="decrease" onClick={decreaseIndex}>
          <div class="decrease-icon"></div>
        </div>
        <div id="increase" onClick={increaseIndex}>
          <div class="increase-icon"></div>
        </div>
    </div>
  )
}
export default Gallery
